import { SxProps, Theme } from "@mui/material";

export const authStyles = {
  authContainer: (theme: Theme): SxProps<Theme> => ({
    display: "flex",
    flexDirection: "column",
    padding: "1rem",
    marginTop: 4,

    maxWidth: {
      xs: "90vw", // small
      sm: "60vw", // tab
      md: "30vw", // large
    },

    marginRight: "auto",
    marginLeft: "auto",
    fontFamily: theme.typography.fontFamily,
  }),

  avatarContainer: {
    marginTop: 4,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  avatar: { m: 1, bgcolor: "#fff", width: "70px", height: "70px" },
  avatarImage: { marginLeft: "auto", marginRight: "auto" },

  textContainer: {
    marginY: 4,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: 2,
  },
  errorText: {
    mt: 2,
    fontSize: "12px",
    color: "red",
    lineHeight: "18.5px",
  },
  actionBtn: { width: "100%", marginTop: "20px", paddingY: "10px" },
};
